import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { classNameWithModifiers } from 'helpers/class-name';
import './Overlay.scss';

const Overlay = ({ className, closeOnScroll, ...rest }) => {
  const ref = useRef();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), [mounted]);

  useEffect(() => {
    if (closeOnScroll) {
      // use existing onClick handler to close the menu when scrolling inside the overlay (ie, outside menu)
      const { onClick } = rest;

      // User opened dropdown by interacting with Dropdown toggle
      // scrolling with mouse pointer on the dropdown toggle should close the dropdown
      window.addEventListener('scroll', onClick);

      // Mouse pointer on overlay - scrolling should close the dropdown
      ref.current.addEventListener('mousemove', () => window.addEventListener('scroll', onClick));

      // User pointer is no longer on overlay - scrolling should not close the dropdown
      ref.current.addEventListener('mouseleave', () => window.removeEventListener('scroll', onClick));

      return () => window.removeEventListener('scroll', onClick);
    }
  }, [ref]);

  return <div ref={ref} className={classNameWithModifiers('overlay', { mounted }, className)} {...rest} />;
};

Overlay.propTypes = {
  className: PropTypes.string,
  closeOnScroll: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Overlay;
